module.exports = __webpack_public_path__ + "static/backlite-media-result-1-e08e705193c42ec24aedfeb846d1a9f7.png";